<breadcrumb
[paginas]="[{route:'/home',name:'Home'},
{route:'/termos-de-uso-de-dados',name:'Temos de Uso de Dados Pessoais'}]"
/>

  <!-- TITULO -->
  <section class="section-saudacao">
    <div class="container">
      <h2 class="titulo-page">Termos de Uso de Dados Pessoais</h2>
      <app-btn-back [backLocation]="'/'"></app-btn-back>
    </div>
  </section>


  <section class="section-termos-de-uso">
    <div class="container">
      <p>
        Para registrar suas atividades no sistema, precisamos da sua autorização para o uso dos seus dados pessoais. Esses dados serão utilizados exclusivamente para fins de gestão, acompanhamento e conformidade das atividades realizadas.
      </p>

      <p>
        <strong>Por que solicitamos sua autorização?</strong> <br />
        - Garantir a transparência no registro das atividades.<br />
        - Cumprir as normas da Secretaria de Educação e a legislação vigente (LGPD).<br />
        - Melhorar a gestão e o acompanhamento das atividades dos psicólogos nas escolas.<br />
      </p>

      <p>
        <strong>Quais dados serão coletados?</strong><br />
        - Nome e CPF do psicólogo.<br />
        - Nome e CRP do psicólogo.<br />
        - Nome e CIE da escola.<br />
        - Data e horário do registro.<br />
        - Endereço IP e informações de conexão (Wi-Fi ou rede cabeada).
      </p>
      <p>
        <strong>Como seus dados serão utilizados?</strong><br />
        - Para registro e gestão das atividades no sistema.<br />
        - Para geração de relatórios e acompanhamento das ações realizadas.<br />
        - Para garantir a conformidade com as normas da Secretaria de Educação.
      </p>
      <p>
      <strong>Seus dados estão seguros!</strong><br />
      - Utilizamos medidas de segurança avançadas para proteger suas informações.<br />
      - Seus dados não serão compartilhados com terceiros sem sua autorização.
      </p>

      <div class="aceite-termos-de-uso">
        <div class="conteudo-autorizacao">
          <h2>⚠️ Autorização para Uso de Dados</h2>
          <!-- <input
          [(ngModel)]="autorizacaoUsoDados" type="checkbox" id="aceite-termos-de-uso"
          [disabled]="userLogado?.autorizacaoUsoDados != null " /> -->
        </div>
        <div class="conteudo-btn-aceite">
          <button class="btn_segundario" (click)="OnSubmit(2)"  [disabled]="userLogado?.autorizacaoUsoDados!=null &&
          userLogado?.autorizacaoUsoDados == 1">
            Não
          </button>
          <button class="btn_primeiro"  (click)="OnSubmit(1)"
          [disabled]="userLogado?.autorizacaoUsoDados!=null &&
          userLogado?.autorizacaoUsoDados == 1">
            Sim
          </button>
        </div>
      </div>
    </div>
  </section>


